import React, { Component } from "react";
import "./salesDataTable.css";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/css/react-bootstrap-table.css";
import Button from "react-bootstrap/Button";
import PDF from "../../assets/images/pdfDownload.png";
import HTML from "../../assets/images/HTMLdownload.png";
import XML from "../../assets/images/xmlDownload.png";
import { temporary } from "../../util/temporary";
import moment from "moment";
import { toastr } from "react-redux-toastr";

class SalesDataTable extends Component {
  constructor(props) {
    super(props);
    this.downloadLinks = this.downloadLinks.bind(this);
    this.showDateFormat = this.showDateFormat.bind(this);
    this.state = {
      isChecked: true,
      multipleDownload: [],
      currentPage: 1,
      pageSize: 10,
      records: 0,
      sortColumnName: "",
      sortOrder: "",
      blocking: true,
      role: "",
      showTable: false,
      salesList: [],
      multipleDownload: [],
      multipleDelete: [],
      deleteData: [],
      count: 0,
    };
  }
  renderShowsTotal(start, to) {
    var text =
      "Showing " +
      start +
      " to " +
      to +
      " of " +
      this.state.records +
      " records.";
    return <p style={{ color: "#f02", fontSize: "12px" }}>{text}</p>;
  }

  pageChanged(pageNumber) {
    this.setState({ currentPage: pageNumber });
    this.props.paginationHandler(
      pageNumber,
      this.state.pageSize,
      this.state.sortColumnName,
      this.state.sortOrder
    );
  }

  sortChanged(sortColumn, order) {
    console.log("sortColumn=", sortColumn);
    this.setState({ currentPage: 1 });
    let sortOrder = order.toString().toLowerCase() === "asc" ? "desc" : "asc";
    this.setState({ sortOrder: sortOrder });
    this.setState({ sortColumnName: sortColumn });

    this.props.paginationHandler(
      this.state.pageNumber,
      this.state.pageSize,
      sortColumn,
      sortOrder
    );
  }

  sizePerPageListChange(sizePerPage) {
    this.setState({ pageSize: sizePerPage });
    this.props.paginationHandler(
      this.state.pageNumber,
      sizePerPage,
      this.state.sortColumnName,
      this.state.sortOrder
    );
  }

  showDateFormat(cell, row) {
    var formattedDate = moment(cell).format("YYYY-MM-DD");
    return <div>{formattedDate}</div>;
  }
  downloadLinks(cell, row) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-evenly",
          alignItems: "self-end",
        }}
      >
        {cell[0] != null ? (
          <img
            className="downloadLinks"
            src={PDF}
            style={{ marginRight: "13px" }}
            title="Click to download PDF"
            height="20px"
            file={cell[0]}
            inv={row.salesInvoiceNumber}
            onClick={this.props.onDownloadClick}
          />
        ) : null}

        {cell[1] != null ? (
          <img
            src={HTML}
            className="downloadLinks"
            style={{ marginRight: "13px" }}
            title="Click to download validation HTML"
            file={cell[1]}
            inv={row.salesInvoiceNumber}
            height="30px"
            onClick={this.props.onDownloadClick}
          />
        ) : null}

        {cell[2] != null ? (
          <img
            src={XML}
            className="downloadLinks"
            title="Click to download validation XML"
            height="30px"
            file={cell[2]}
            inv={row.salesInvoiceNumber}
            onClick={this.props.onDownloadClick}
          />
        ) : null}
      </div>
    );
  }

  handleBulkDownload = () => {
    console.log("Handle Bulk Download this. is", this);

    if (this.state.count > 10) {
      toastr.error("Maximum 10 values can be downloaded at a time");
    } else {
      var bulkVal = this.state.multipleDownload.filter(function (el) {
        return el != null;
      });

      var noCommonName = new Set(bulkVal);

      console.log("Handle Bulk Download after filter is", noCommonName);
      this.props.onBulkDowloadHandler(noCommonName);
    }
  };

  handleOnSelect = (row, isSelect, rowIndex, e) => {
    console.log(
      "rowSelect:",
      row,
      "isSelect:",
      isSelect,
      "e:",
      (this.state.currentPage - 1) * 10 + e
    );

    this.setState({ isChecked: false });
    if (isSelect) {
      this.state.count++;
      this.setState(() => ({
        multipleDownload: [
          ...this.state.multipleDownload,
          row.downloadLinks[0],
        ],
      }));
      console.log("total rows selected are=", this.state.count);
    } else {
      this.state.count--;
      var temparr = this.state.multipleDownload;
      console.log("total rows selected are=", this.state.count);
      var zero = 0;

      for (var i = 0; i <= temparr.length; i++) {
        if (zero == 0 && temparr[i] == row.downloadLinks[0]) {
          temparr.splice(i, 1);
          zero = 1;
        }
      }
      console.log("TEMP ARRAY=", temparr);
      this.setState(() => ({
        multipleDownload: temparr,
      }));
    }
    console.log("Links =", row.downloadLinks[0]);
    console.log("multiple download file=", this.state.multipleDownload);
    if (this.state.count === 0) {
      this.setState({ isChecked: true });
    }
  };

  handleOnSelectAll = (isSelect, rows) => {
    console.log("Rows:", rows);
    var multipleSalesLinks = [];
    rows.map((r) => {
      if (r.downloadLinks[0] != null) {
        multipleSalesLinks.push(r.downloadLinks[0]);
      }
    });
    console.log("multiple sales link=", multipleSalesLinks);
    if (isSelect) {
      this.setState(() => ({
        multipleDownload: multipleSalesLinks,
      }));
      this.state.count = rows.length;
      console.log("total rows selected are=", this.state.count);
    } else {
      this.setState(() => ({
        multipleDownload: [],
      }));
      this.state.count = 0;
      console.log("total rows selected are=", this.state.count);
    }
  };

  selectRowProp = {
    mode: "checkbox",
    //clickToSelect: true,
    checkbox: true,
    bgColor: "rgb(238, 193, 213)",
    onSelect: this.handleOnSelect,
    onSelectAll: this.handleOnSelectAll,
  };

  componentWillReceiveProps(nextProps) {
    console.log("recieveProps:", nextProps);
    if (nextProps.data) {
      if (this.props.searchClear === true) {
        this.setState({ currentPage: 1 });
      }
      if (this.props.clearButton === true) {
        this.setState({ count: 0 });
        this.setState({ multipleDownload: [] });
      }
      this.setState({ salesList: nextProps.data.salesDtoList });
      this.setState({ records: nextProps.data.records });
      this.setState({ role: nextProps.role });
      this.setState({ showTable: nextProps.showSalesResults });
      console.log(
        "this is the sales table list from nextProps",
        this.state.salesList
      );
      console.log("this is show table from nextProps", this.state.showTable);
    }
  }

  componentWillMount() {
    console.log("this.props datatable" + this.props);
  }

  render() {
    // var data = temporary;
    console.log("table props", this.props);
    console.log("this is the sales table list", this.state.salesList);
    console.log("this is show table", this.state.showTable);
    console.log("search clear:", this.props.searchClear);
    const options = {
      page: this.state.currentPage,
      sizePerPage: 10,
      prePage: "<",
      nextPage: ">",
      firstPage: "First",
      lastPage: "Last",
      paginationShowsTotal: this.renderShowsTotal.bind(this),
      onPageChange: this.pageChanged.bind(this),
      onSizePerPageList: this.sizePerPageListChange.bind(this),
      onSortChange: this.sortChanged.bind(this),
    };
    return (
      <div className="Salestable" style={{ overflowX: "auto" }}>
        {this.props.showSalesResults && this.state ? (
          <div style={{ margin: "2.5%" }}>
            <BootstrapTable
              options={options}
              data={this.state.salesList}
              pagination={true}
              selectRow={this.selectRowProp}
              bordered={true}
              striped={true}
              hover={true}
              remote={true}
              fetchInfo={{ dataTotalSize: this.state.records }}
            >
              <TableHeaderColumn
                dataField="salesInvoiceNumber"
                dataAlign="center"
                dataSort={true}
                isKey
              >
                Invoice No
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="invoiceDate"
                dataAlign="center"
                dataSort={true}
                dataFormat={this.showDateFormat}
              >
                Invoice Date
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="nmsc"
                dataAlign="center"
                dataSort={true}
              >
                NMSC
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="supplier"
                dataAlign="center"
                dataSort={true}
              >
                Source
              </TableHeaderColumn>
              <TableHeaderColumn
                dataSort={false}
                dataField="currency"
                dataAlign="center"
              >
                Currency
              </TableHeaderColumn>
              <TableHeaderColumn
                dataSort={false}
                dataField="totalNumberOfVehicles"
                dataAlign="center"
              >
                Number of VINs
              </TableHeaderColumn>
              <TableHeaderColumn
                dataSort={false}
                dataField="totalAmount"
                dataAlign="center"
              >
                Total Amount
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="vesselName"
                dataAlign="center"
                dataSort={true}
              >
                Vessel Name
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="downloadLinks"
                dataAlign="center"
                dataSort={false}
                dataFormat={this.downloadLinks}
              >
                Links
              </TableHeaderColumn>
            </BootstrapTable>
            {/* <input
              type="button"
              className="btn"
              style={{
                borderRadius: "20px",
                backgroundColor: "#E50000",
                height: "39px",
                fontFamily: "Roboto",
                color: "white",
              }}
              value="DOWNLOAD"
            /> */}
            <input
              type="button"
              onClick={this.handleBulkDownload}
              disabled={this.state.count <= 0 ? true : false}
              className="btn"
              style={{
                marginLeft: "1%",
                borderRadius: "20px",
                backgroundColor: "#E50000",
                height: "39px",
                fontFamily: "Roboto",
                color: "white",
              }}
              value="BULK DOWNLOAD"
            />

            {<p style={{ color: "black", marginLeft: "90px" }}></p>}
          </div>
        ) : null}
      </div>
    );
  }
}

export default SalesDataTable;
